import * as z from "zod/v4";

export const handleReviewEvent = {
  name: "handleReviewEvent" as const,
  input: z.object({ email: z.string(), discountCode: z.string().optional() }),
  output: z.object({ success: z.boolean() }),
};
